<template>
  <transition name="fade">
    <div class="vote-detail-dialog" v-show="visible" @click.self="handleClose">
      <div class="dialog-content">
        <Icon type="md-close" class="close-icon" @click="handleClose"></Icon>
        <div class="title">投票详情</div>

        <!-- 上半部分：作品信息 -->
        <div class="dialog-top">
          <div class="left-image">
            <img :src="info.match_post_image | default_img" class="work-cover" />
          </div>
          <div class="right-info">
            <div class="name-row">{{ info.match_post_name || '-'}}</div>
            <div>
              <div class="info-row">
                <span class="label">当前排名</span>
                <span class="value rank-value">{{ info.rank || '-'
                }}</span>
              </div>
              <div class="info-row">
                <span class="label">作品名称</span>
                <span class="value">{{ info.match_post_name || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">作者姓名</span>
                <span class="value">{{ info.author || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">当前总票数</span>
                <span class="value">{{ info.total_vote || 0 }}</span>
              </div>
              <div class="info-row">
                <span class="label">今日获票数</span>
                <span class="value">{{ info.today_vote || 0 }}</span>
              </div>
              <div class="info-row">
                <span class="label">商品已售</span>
                <span class="value">{{ info.sale_count || 0 }}</span>
              </div>
            </div>
            <div class="btn-box">
              <span class="detail-btn" @click="goDetail(info.vote_qrcode)">查看商品详情</span>
            </div>
          </div>
        </div>

        <!-- 下半部分：投票记录列表 -->
        <div class="dialog-bottom">
          <div class="list-title">投票记录({{ allData.length }})</div>
          <div class="vote-list" ref="voteList" @scroll="handleScroll">
            <transition-group name="list-slide">
              <div v-for="(item, index) in voteRecords" :key="item.id || index" class="vote-item">
                <div class="voter-info">
                  <img :src="item.avatar | default_img" class="voter-avatar" />
                  <span class="voter-name">{{ item.name || item.nickname || item.username || '匿名用户' }}</span>
                </div>
                <div class="vote-time">{{ formatTime(item.create_time) }}</div>
              </div>
            </transition-group>
            <div v-if="!allData.length" class="empty-text">暂无投票记录</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import dayjs from 'dayjs';
import Empty from '@/components/Empty.vue';
import { throttle } from 'lodash-es';
import { GetMatchVoteRankingRankDetai } from '@/api/social';
export default {
  name: 'VoteDetailDialog',
  components: {
    Empty
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rankId: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      allData: [],
      listIndex: 0,
      voteRecords: [],
      info: {},
      timer: null,
      lastVoteId: null,
      scrollTimer: null,
      isScrolling: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getVoteRecords();
      } else {
        this.resetData();
      }
    }
  },
  methods: {
    async getVoteRecords() {
      try {
        const { data } = await GetMatchVoteRankingRankDetai({ rank_uuid: this.rankId });
        const { vote_list, ...otherData } = data || {};
        this.info = otherData || {};
        this.allData = Object.freeze(vote_list || []);
        this.voteRecords = this.allData.slice(0, 50);
        this.listIndex = 50;


        // this.allData =  Object.freeze(new Array(Number(100000)).fill(null).map((_, index) => {
        //   return {
        //     id: index + 1,
        //     avatar: '',
        //     nickname: '作者' + (index + 1),
        //     username: 'username1' + (index + 1),
        //     voteTime: new Date(Date.now() - 1000 * index)
        //   };
        // }));
        // this.voteRecords = this.allData.slice(0, 50);
        // this.listIndex = 50;
      } catch (e) {
        console.error('获取投票记录失败', e);
        // this.$layer.msg(e.msg || '获取投票记录失败');
      }
    },
    resetData() {
      this.allData = [];
      this.listIndex = 0;
      this.voteRecords = [];
    },
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleScroll: throttle(function() {

      const el = this.$refs.voteList;
      if (!el) return;

      // scrollHeight: 元素内容的总高度
      // scrollTop: 滚动条滚动的距离
      // clientHeight: 元素可视区域的高度
      const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight;

      // 当距离底部小于等于预设阈值（如50px）时，判定为触底
      if (distanceToBottom <= 50 && this.voteRecords.length < this.allData.length) {
        console.log('滚动到最底部了');
        // 在此处执行触底加载等逻辑
        this.voteRecords = [ ...this.voteRecords, ...this.allData.slice(this.listIndex, this.listIndex + 50)];
        this.listIndex += 50;
      }
    }, 500, {
      leading: true,  // 第一次触发时立即执行
    }),
    goDetail(product_uuid) {
      this.$emit('handleVote');
      // this.$router.push({name:'GoodsDetail',params:{product_uuid}});
    }
  }
};
</script>

<style lang="scss" scoped>
.vote-detail-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog-content {
    background: #ffffff;
    border-radius: 32px;
    position: relative;
    width: 880px;
    height: 832px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 18px 32px 28px 32px;

    .title {
      font-weight: bold;
      font-size: 20px;
      line-height: 30px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .close-icon {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 24px;
      cursor: pointer;
      color: #999;
      z-index: 10;
      transition: color 0.3s;

      &:hover {
        color: #666;
      }
    }

    // 上半部分
    .dialog-top {
      display: flex;
      margin-top: 15px;

      .left-image {
        width: 320px;
        height: 380px;
        flex-shrink: 0;
        border: 1px solid #E3E3E3;
        border-radius: 4px;

        .work-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .right-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 24px;

        .name-row {
          font-weight: bold;
          font-size: 20px;
          line-height: 24px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;

          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }

        .info-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
          border-bottom: 1px solid #E3E3E3;
          padding-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }

          .label {
            font-weight: 500;
            font-size: 14px;
            line-height: 21px;
            color: #666666;
            text-align: left;
            font-style: normal;
            text-transform: none;
            flex-shrink: 0;
          }

          .value {
            font-weight: 500;
            font-size: 14px;
            line-height: 21px;
            color: #333333;
            text-align: right;
            font-style: normal;
            text-transform: none;
            max-width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-break: break-all;

            &.rank-value {
              color: #FF5967;
              font-weight: bold;
              font-size: 16px;
              line-height: 24px;

              &.rank-1 {
                color: #FFD700;
              }

              &.rank-2 {
                color: #C0C0C0;
              }

              &.rank-3 {
                color: #CD7F32;
              }
            }
          }
        }

        .btn-box {
          width: 100%;
          text-align: center;

          .detail-btn {
            cursor: pointer;
            display: inline-block;
            width: 148px;
            height: 40px;
            background: #FF5967;
            border-radius: 20px 20px 20px 20px;

            font-weight: 400;
            font-size: 14px;
            line-height: 40px;
            color: #FFFFFF;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }

    // 下半部分
    .dialog-bottom {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-top: 23px;
      overflow: hidden;

      .list-title {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #000000;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .vote-list {
        flex: 1;
        overflow-y: auto;
        margin-top: 16px;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: #ddd;
          border-radius: 3px;

          &:hover {
            background: #ccc;
          }
        }

        .vote-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 2px 0 11px 0;
          border-bottom: 1px solid #f5f5f5;
          margin-bottom: 12px;

          &:last-child {
            border-bottom: none;
            margin-bottom: 0;
          }

          .voter-info {
            display: flex;
            align-items: center;
            flex: 1;

            .voter-avatar {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              margin-right: 8px;
              object-fit: cover;
            }

            .voter-name {
              font-weight: 400;
              font-size: 14px;
              line-height: 21px;
              color: #333333;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
          }

          .vote-time {
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: #666666;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }

        .empty-text {
          text-align: center;
          padding: 40px 0;
          color: #999;
          font-size: 14px;
        }
      }
    }
  }
}

// 动画效果
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.list-slide-enter-active {
  animation: slideDown 0.5s ease-out;
}

.list-slide-leave-active {
  animation: slideDown 0.5s ease-out reverse;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
